<template>
  <body-chrome>

    <!-- only show navbar if logged in -->
    <oidc-restricted>
      <app-navbar/>
    </oidc-restricted>
    <!-- eo:only show navbar if logged in -->

    <!-- maintain a list of devices -->
    <oidc-restricted require-token>
      <background-monitor/>
    </oidc-restricted>
    <!-- eo:maintain a list of devices -->

    <!-- show page or page restricted message -->
    <oidc-page-restricted :title="fullProductName" icon="bell">
      <router-view/>
    </oidc-page-restricted>
    <!-- eo:show page or page restricted message -->

    <portal-target name="outer"/>

  </body-chrome>
</template>

<script>
import { productName, uiBuildVersion } from '@/services/branding'
import BackgroundMonitor from '@/components/BackgroundMonitor.vue'
import AppNavbar from '@/components/NavBar.vue'

export default {
  components: { AppNavbar, BackgroundMonitor },
  computed: {
    fullProductName () { return `${productName} v${uiBuildVersion()}` }
  }
}
</script>